import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import useContent from 'store/content'
import Button from 'components/Button'
import Toast from 'components/Toast'
import Templator from 'utils/Templator'
import { useTheme } from 'styled-components'
import { withTranslation } from 'react-i18next'
import { getUserInput, saveUserInput, triggerEmail } from 'libs/localApi'
import { isLinkInternal, getRouterLink, setCurrentDomainToLink } from 'utils/index'

import { MdError } from 'react-icons/md'

import Validation from './Validation'
import { StyledLoader } from './styles'

import { withUtm } from 'utils/utm'


const Trigger = ({ appId, id, type, typeId, t }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const router = useRouter()

  const content = useContent()
  const name = content.get.moduleName(type, typeId)
  const trigger = content.get.triggerById(id)

  const theme = useTheme()

  const hasValidations = trigger && trigger.onTrigger && trigger.onTrigger.validate

  useEffect(() => {
    if (error) setTimeout(() => resetError(), 5000)
  }, [error])

  const resetError = () => {
    setError(false)
    setLoading(false)
  }

  const redirect = (urlTo) => {
    setTimeout(() => {
      if (isLinkInternal(urlTo)) {
        const { href, hardNavigation } = getRouterLink(urlTo, router.query.appId, router.asPath)
        if (hardNavigation) {
          window.location.href = withUtm(href)
        } else {
          router.push(withUtm(href))
        }
      } else {
        window.location.href = withUtm(setCurrentDomainToLink(urlTo))
      }
      setLoading(false)
    }, 750)
  }

  const sendEmail = async (email) => {
    await triggerEmail(email).then((res) => {
      if (res.status === 500) {
        setError(true)
        return
      }
      const template = new Templator(email.appId)
      const urlTo = template.format(trigger.onSuccess.params.url, email.input)
      redirect(urlTo)
    })
  }

  const handleOnSubmit = async (formData) => {
    setLoading(true)
    const data = formData || getUserInput(appId)

    if (formData) {
      Object.entries(formData).forEach(([key, val]) => {
        saveUserInput(appId, key, val)
      })
    }

    if (trigger.type === 'email') {
      const email = { appId: appId, type, id: typeId, trigger: trigger, input: data }
      await sendEmail(email)
    } else {
      const urlTo = new Templator().format(trigger.onSuccess.params.url, data)
      redirect(urlTo)
    }
  }
  return (
    <div>
      {hasValidations ? (
        <Validation
          appId={appId}
          dataGa={`button trigger ${name}`}
          onSubmit={handleOnSubmit}
          trigger={trigger}
          disabled={!theme.trigger_hide_loader && loading}
        />
      ) : (
        <Button
          disabled={!theme.trigger_hide_loader && loading}
          dataGa={`button trigger ${name}`}
          id={`${name} button`}
          children={
            <>
              {loading && <StyledLoader />}
              {trigger.style.text}
            </>
          }
          onClick={() => handleOnSubmit(null)}
        />
      )}


      {error && (
        <Toast
          text={t('error.tryAgain')}
          icon={<MdError style={{ color: 'red' }} />}
          color="red"
          title={t('error.error')}
          onClose={resetError}
        />
      )}
    </div>
  )
}

Trigger.propTypes = {
  appId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  typeId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation()(Trigger)
